import api from "../config/api";
import {  StudentFeeDetailsParams } from "../redux/actions/studentFeesDetailsAction";



export const getStudentFeesDetails = async(params:StudentFeeDetailsParams)=>{
    return await api.get('/student/StudentGetFeesDetails/',{
        params:{
            branchId:params.branchId,
            courseId:params.courseId,
            batch:params.batch,
            year:params.year,
            admissionNumber:params.admissionNumber
        }
    })
}